import {
  ChevronsRightIcon,
  Edit,
  Minus,
  Plus,
  Search,
  Trash,
  Download,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  AddButton,
  CustomConfirmModal,
  PaginationDropdown,
} from "../../common/GeneralComponent";

import { Pagination } from "@mui/material";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../utils/functions";
// import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loader from "../../partials/Loader";
import Loader from "../../partials/Loader";
import 'font-awesome/css/font-awesome.min.css';
import * as XLSX from "xlsx";


import GeneralFooter from "../../common/GeneralFooter";
import PermissionButton from "../../common/PermissionButton";

const Groups = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [groupsData, setGroupsData] = useState([]);
  const [status, setStatus] = useState("");
  const [groups, setGroups] = useState("");
   const [loader, setLoader] = useState(true);
  const [groupOptions, setGroupOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [isModalVisible, setModalVisible] = useState(false);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  });

  const { user: loggedInUser } = useSelector((state) => state.auth);
  const permissions = loggedInUser?.user_permissions || [];

  const fetchGroups = async () => {
    try {
      const queryParams = groups
        ? { id: groups }
        : {
            search: search || undefined,
            page: pagination.currentPage,
            limit: pagination.pageSize,
            status: status !== "" ? status : undefined,
          };

             
          

      const response = await fetchData(
        "groups",
        "GET",
        null,
        {},
        queryParams,
        navigate,
        "/groups",
        dispatch
      );

      setLoader(false);
      setGroupsData(response?.data || []);

      setPagination((prev) => ({
        ...prev,
        currentPage: response?.pagination?.currentPage || prev.currentPage,
        totalItems: response?.pagination?.totalItems || 0,
        totalPages: response?.pagination?.totalPages || 0,
      }));
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  const exportToExcel = async () => {
    try {
      setIsExporting(true);
      const response = await fetchData(
        "groups",
        "GET",
        null,
        {},
        { search: search || undefined, page: 1, limit: 10000 },
        navigate,
        "/groups",
        dispatch
      );

      const allGroups = response?.data || [];

      if (!allGroups.length) {
        toast.warning("No groups to export");
        return;
      }

      const excelData = allGroups.map((group, index) => ({
        "Sr. No": index + 1,
        Name: group.name || "",
        "Allowed Platforms": group.allowed_platforms || "",
        Status: group.status === 1 ? "Active" : "Inactive",
        "Created At": group.created_at
          ? new Date(group.created_at).toLocaleDateString()
          : "",
        "Updated At": group.updated_at
          ? new Date(group.updated_at).toLocaleDateString()
          : "",
        "Permissions": group.permissions 
          ? group.permissions.map(p => p.permission_name).join(", ")
          : "",
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Groups");

      XLSX.writeFile(
        workbook,
        // `groups_export_${new Date().toISOString().split("T")[0]}.xlsx`
        `groups_export_${new Date().toISOString().split("T")[0]}.csv`,
      );
      toast.success(`Successfully exported ${allGroups.length} groups to Excel`);
    } catch (error) {
      console.error(error);
      toast.error("Failed to export groups to Excel");
    } finally {
      setIsExporting(false);
    }
  };


  useEffect(() => {
    fetchGroups();
  }, [pagination.currentPage, pagination.pageSize, search, groups, status]);

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({ ...prev, currentPage: value }));
  };

  const handlePageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, pageSize: size, currentPage: 1 }));
  };

  const columns = [
    {
      name: <span className="text-[0.819rem] uppercase">Name</span>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <span className="text-[0.819rem] uppercase ">Status</span>,
      cell: (row) => (
        <span
          className={`py-1 px-2 text-[0.85em] rounded ${
            row.status === 1 ? "bg-success text-white" : "bg-red-500 text-white"
          }`}
        >
          {row.status === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];
  {
      if (
        permissions.includes("group-update") ||
        permissions.includes("group-delete")
      ) {
        columns.push({
          name: <span className="text-[0.819rem] uppercase">Action</span>,
          cell: (row) => (
            <div className="flex gap-2">
              {/* <Link to={`/groups/edit/${row.id}`}>
          <i className="fa-solid fa-pen-to-square fa-lg"></i>
        </Link>
        <button onClick={() => showDeleteModal(row.id)}>
          <i
            className="fa fa-trash fa-lg text-primaryDark"
            aria-hidden="true"
          ></i>
        </button> */}
              <PermissionButton
                hasPermission={permissions.includes("group-update")}
                // faIcon="fa-solid fa-pen-to-square fa-lg"
                // onlyIcon
                to={`/groups/edit/${row.id}`}
                faIcon="fa-solid fa-pen-to-square fa-lg"
                onlyIcon={true}
                // className="text-primaryDark hover:text-[#137e81]" // keeps it like your <a>
                enabledClass="" // no background
                disabledClass="opacity-50 cursor-not-allowed"
              />
              <PermissionButton
                hasPermission={permissions.includes("group-delete")}
                faIcon="fa fa-trash fa-lg text-primaryDark"
                onlyIcon
                onClick={() => showDeleteModal(row.id)}
                className="p-2 rounded-full bg-gray-200 text-[#137e81] hover:text-white"
                enabledClass=""
                disabledClass="opacity-50 cursor-not-allowed bg-gray-300"
              />

              <CustomConfirmModal
                isVisible={isModalVisible}
                onConfirm={handleDelete}
                onCancel={() => setModalVisible(false)}
                message="Are you sure you want to delete this Group?"
              />
            </div>
          ),
        });
      }
}

  const handleDelete = async () => {
    setModalVisible(false);
    setGroupsData((prev) => prev.filter((group) => group.id !== selectedUuid));

    try {
      const response = await fetchData(
        `groups`,
        "DELETE",
        { id: selectedUuid },
        {},
        {},
        navigate,
        "/groups",
        dispatch
      );
      if (!response?.success) {
        throw new Error(response?.message || "Failed to delete the group.");
      }
      toast.success("Group deleted successfully.");
    } catch (error) {
      console.error("Error deleting group:", error);
      toast.error(
        error?.message || "An error occurred while deleting the group."
      );
      fetchGroups();
    }
  };

  const showDeleteModal = (id) => {
    setSelectedUuid(id);
    setModalVisible(true);
  };

  const customStyles = {
    headCells: {
      style: {
        border: "1px solid #f3f3f3",
        backgroundColor: "#fff",
        color: "black",
        fontWeight: "bold",
        fontSize: "1.075rem",
        textAlign: "center",
      },
    },
    cells: {
      style: {
        border: "1px solid #f3f3f3",
        textAlign: "center",
      },
    },
  };

  return (
    <div className="my-4 w-full flex flex-col justify-between items-center">
      {loader && <Loader />}
      <div className="flex lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Manage Groups
        </h1>
        <div className="flex gap-3">
          <button
            onClick={exportToExcel}
            disabled={isExporting}
            className={`flex items-center gap-2 px-4 py-1 text-sm bg-[#137e81] hover:bg-green-700 text-white rounded-md transition-colors ${
              isExporting ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <Download size={16} />
            {isExporting ? "Exporting..." : "Export Excel"}
          </button>
          {/* <Link to="add">
            <AddButton text="Add" icon={ChevronsRightIcon} />
          </Link> */}

          <PermissionButton
            hasPermission={permissions.includes("group-create")}
            to="add"
            faIcon="fa fa-plus"
            text="Add"
            className="flex items-center gap-2 py-[0.375rem] px-[0.75rem] rounded font-[InterLight] lg:text-[15px] text-[12px]"
            enabledClass="bg-[#be9609] text-white w-auto opacity-95 hover:opacity-85"
            disabledClass="bg-[#be9609] text-white opacity-50 cursor-not-allowed"
          />
        </div>
      </div>

      <div className="rounded-lg mb-[30px] mt-4 shadow w-full bg-white">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px] tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Group List
          </h1>
        </div>

        <div className="p-[1.25rem] w-full">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start gap-2 lg:items-center items-start mb-[6px] w-full">
            {/* Show Entries Dropdown */}
            <PaginationDropdown
              value={pagination.pageSize}
              onChange={handlePageSizeChange}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
              ]}
            />

            {/* Search */}
            <input
              onChange={(e) => {
                setSearch(e.target.value);
                setPagination((prev) => ({ ...prev, currentPage: 1 }));
              }}
              placeholder="Search..."
              type="search"
              className="font-[Light] text-[#212529] text-[14px] flex items-center bg-[#f1f4f8] border-[#ebeef2] border-[1px] rounded-md px-3 py-1 outline-none"
            />
          </div>

          <DataTable
            columns={columns}
            data={groupsData}
            customStyles={customStyles}
            highlightOnHover
          />
          <GeneralFooter
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            dataLength={groupsData.length}
          />
        </div>
      </div>
    </div>
  );
};

export default Groups;